module.exports = __webpack_public_path__ + "img/pro_detail_6.d5ac45fc.jpg";